import React from "react";
import { MainText, Box } from "app/components/common";

const GoalBar = ({ goalTitle, goalDone, goalNumber }) => {
  const progress = (goalDone / goalNumber) * 100;
  const progressToDisplay = progress >= 100 ? 100 : progress?.toFixed(0);

  return (
    <Box
      marginTop="m"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      width="100%"
    >
      <Box
        width="100%"
        justifyContent="space-between"
        flexDirection="row"
        marginBottom="s"
        flex={1}
      >
        <MainText variant="l3-regular" color="neutral.900">
          {goalTitle}
        </MainText>
        <MainText
          marginLeft="s"
          variant="l3-regular"
          color="neutral.900"
          fontWeight="600"
        >{`${goalDone}/${goalNumber}`}</MainText>
      </Box>
      <Box width="100%">
        <Box
          borderRadius={25}
          position="absolute"
          left={0}
          height={5}
          zIndex={2}
          backgroundColor="brand.500"
          width={`${progressToDisplay}%`}
        />
        <Box
          borderRadius={25}
          position="absolute"
          left={0}
          height={5}
          zIndex={1}
          width="100%"
          backgroundColor="neutral.200"
        />
      </Box>
    </Box>
  );
};

export default GoalBar;
